<template>
  <div>
    <h2 class="mb-4">รายงานการร้องขอหนังสือ</h2>
    <CRow>
      <CCol md="6">
        <v-date-picker v-model="date" is-range>
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex justify-center items-center">
              <CInput
                :value="inputValue.start"
                v-on="inputEvents.start"
                placeholder="เลือกวันเริ่มต้นค้นหา"
                class="width-50p"
              />
              <CInput
                :value="inputValue.end"
                v-on="inputEvents.end"
                placeholder="เลือกวันสิ้นสุดการค้นหา"
                class="width-50p ml-3"
              />
            </div>
          </template>
        </v-date-picker>
      </CCol>
      <CCol md="3">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: {
        start: null,
        end: null
      }
    }
  },
  methods: {
    handleSearch() {
      // TODO : call API
    }
  }
}
</script>
